import React from 'react';
import { Typography, Badge } from '@one-thd/sui-atomic-components';
import { useCommonContext } from '../../../hooks/useContexts';
import { UNAVAILABLE_IMAGE_URL } from '../../../constants/general';
var BarcodeItems = function (_a) {
    var items = _a.items;
    var isMobile = useCommonContext().isMobile;
    var itemCountMax = isMobile ? 4 : 6;
    var getAdditionalItemCount = function () {
        var additionalItemsCount = items.length - (itemCountMax - 1);
        var output = additionalItemsCount > 0 ? additionalItemsCount : 0;
        return "+".concat(output);
    };
    // Maps return quantity digit length to correct badge center position
    var BADGE_LEFT_POSITIONS = {
        1: 'sui-left-9',
        2: 'sui-left-[3.3rem]',
    };
    return (React.createElement("div", { className: "sui-flex sui-gap-4" }, items.map(function (item, index) {
        var _a;
        if (index > itemCountMax - 1)
            return null;
        if (index === itemCountMax - 1 && items.length > itemCountMax) {
            return (React.createElement("div", { className: "sui-grid sui-bg-strong sui-rounded-base sui-place-items-center sui-z-10 overflow-items-indicator", key: item === null || item === void 0 ? void 0 : item.lineId },
                React.createElement(Typography, { height: "tight", variant: "body-base" }, getAdditionalItemCount())));
        }
        var badgeLeftPosition = BADGE_LEFT_POSITIONS[((_a = item.currentQuantity) === null || _a === void 0 ? void 0 : _a.toString().length) || 0] ||
            'sui-left-9';
        return (React.createElement("div", { className: "sui-relative", key: item === null || item === void 0 ? void 0 : item.lineId },
            React.createElement("img", { src: (item === null || item === void 0 ? void 0 : item.imageUrl) || UNAVAILABLE_IMAGE_URL, height: 48, width: 48, alt: (item === null || item === void 0 ? void 0 : item.description) || 'Product', className: "sui-max-w-none", "data-testid": "item-img" }),
            (item.currentQuantity || 0) > 1 && (React.createElement("div", { className: "sui-mr-4 sui-z-10 sui-absolute sui-bottom-9 ".concat(badgeLeftPosition) },
                React.createElement(Badge, { size: "small" }, item.currentQuantity)))));
    })));
};
export default BarcodeItems;
